import React from 'react';
import { Link } from 'react-router-dom';
import { FiPlay } from 'react-icons/fi';
import { PATHS } from '@/routes/paths';
import useNextMission from '@/hooks/useNextMission';

// Hero grande "Continuar" da Versão B: card laranja full-width que leva o aluno
// direto pra trilha atual. Missão de hoje vem da matéria do próximo bloco pendente.
export function HeroContinue() {
  const mission = useNextMission();

  return (
    <Link
      to={PATHS.LEARNING_PATH.CURRENT}
      className="group relative flex items-center gap-5 overflow-hidden rounded-[28px] p-6 shadow-card transition-[transform,box-shadow] duration-150 ease-out-strong hover:-translate-y-0.5 hover:shadow-card-hover active:scale-[0.99]"
      style={{ background: 'var(--gradient-mission-hero)' }}
    >
      {/* Decorações sutis: nuvenzinhas / faísca / aviãozinho */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-6 top-4 text-2xl opacity-30"
        style={{ transform: 'rotate(-12deg)' }}
      >
        ✈️
      </span>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-24 top-8 text-xl opacity-25"
      >
        ✨
      </span>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute bottom-3 right-10 text-2xl opacity-25"
      >
        ☁️
      </span>

      {/* Círculo branco com play laranja — relevo 3D/chanfrado igual ao botão da trilha */}
      <span
        className="relative z-10 flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-full bg-white"
        style={{ boxShadow: '0 4px 0 rgba(0,0,0,0.14), 0 8px 16px rgba(0,0,0,0.22)' }}
      >
        <FiPlay
          className="h-8 w-8 translate-x-0.5"
          style={{ color: 'var(--color-mission)' }}
          fill="currentColor"
        />
      </span>

      {/* Texto */}
      <span className="relative z-10 min-w-0 flex-1">
        <span className="block text-3xl font-extrabold leading-tight text-white sm:text-4xl">Continuar</span>
        {mission && (
          <span className="mt-1 flex flex-wrap items-center gap-2">
            <span className="text-sm font-semibold text-white/90">Missão de hoje:</span>
            <span className="rounded-full bg-[var(--color-badge-gold)] px-3 py-1 text-xs font-extrabold text-[var(--color-badge-gold-text)]">{mission}</span>
          </span>
        )}
      </span>
    </Link>
  );
}
